import React from 'react';
import { Colors, Text } from 'library';
import { Grid, Rating as MuiRating } from '@mui/material';
import { StarOutlineRounded, StarRounded } from '@mui/icons-material';

export default function SmallRating({ reviews }: { reviews: { average_score: number; total_reviews: number } | null }) {
    return reviews?.average_score && reviews.average_score > 3.5 ? (
        <Grid
            container
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
            paddingTop={2}
            paddingRight={2}
        >
            <MuiRating
                name="read-only"
                value={reviews.average_score}
                readOnly
                icon={<StarRounded style={{ height: 24, width: 24, color: '#ffe200' }} />}
                emptyIcon={<StarOutlineRounded style={{ height: 24, width: 24, color: Colors.disabledGrey }} />}
                precision={0.1}
            />
            <Text variant="body2" textStyle={{ paddingLeft: 5 }}>
                ({reviews.total_reviews})
            </Text>
        </Grid>
    ) : null;
}
